var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkingErasedWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15385 4.51929C4.7911 4.51929 5.30769 5.03588 5.30769 5.67313V27.9808C5.30769 28.6181 4.7911 29.1347 4.15385 29.1347C3.51659 29.1347 3 28.6181 3 27.9808V5.67313C3 5.03588 3.51659 4.51929 4.15385 4.51929Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9231 13.7501C15.5603 13.7501 16.0769 14.2667 16.0769 14.9039V18.7501C16.0769 19.3873 15.5603 19.9039 14.9231 19.9039C14.2858 19.9039 13.7692 19.3873 13.7692 18.7501V14.9039C13.7692 14.2667 14.2858 13.7501 14.9231 13.7501Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6923 4.51929C26.3296 4.51929 26.8462 5.03588 26.8462 5.67313L26.9492 13.7501C26.9492 14.3873 26.4326 14.9039 25.7954 14.9039C25.1581 14.9039 24.6415 14.3873 24.6415 13.7501L24.5385 5.67313C24.5385 5.03588 25.0551 4.51929 25.6923 4.51929Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9231 4.51929C15.5603 4.51929 16.0769 5.03588 16.0769 5.67313V9.51929C16.0769 10.1565 15.5603 10.6731 14.9231 10.6731C14.2858 10.6731 13.7692 10.1565 13.7692 9.51929V5.67313C13.7692 5.03588 14.2858 4.51929 14.9231 4.51929Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4896_18942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5386 31.5705C28.4329 31.5705 31.5899 28.4135 31.5899 24.5192C31.5899 20.6249 28.4329 17.4679 24.5386 17.4679C20.6443 17.4679 17.4873 20.6249 17.4873 24.5192C17.4873 28.4135 20.6443 31.5705 24.5386 31.5705Z",
    stroke: "#fff",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5391 28.0448H24.5431",
    stroke: "#fff",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4883 22.4041C22.6541 21.9329 22.9813 21.5355 23.412 21.2824C23.8427 21.0292 24.349 20.9367 24.8414 21.0212C25.3338 21.1056 25.7804 21.3616 26.1021 21.7438C26.4238 22.126 26.5999 22.6097 26.5992 23.1093C26.5992 24.5195 24.4838 25.2246 24.4838 25.2246",
    stroke: "#fff",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4896_18942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9231,
    height: 16.9231,
    fill: "#000",
    transform: "translate(16.0762 16.0576)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkingErasedWhite);
export default __webpack_public_path__ + "static/media/marking-erased-white.8eeb84bfe5dc49dc7ea9e173140073f1.svg";
export { ForwardRef as ReactComponent };